import { useCallback } from "react";
import { useAxiosInstances } from "../../axios-instance";
import {
  ILayoutRecorte,
  ILayoutRecorteTable,
  IRecorte,
} from "../../../application/models";

export const useLayoutRecorteExtracaoApi = () => {
  const { axiosAuthInstance } = useAxiosInstances();

  const deleteLayoutRecorteApi = useCallback(
    async (data: {
      IdVelesGeoLayoutExtracao: number;
    }): Promise<ILayoutRecorte> => {
      try {
        const result = await axiosAuthInstance.delete(
          `/geo-veles/layout-recorte/${data.IdVelesGeoLayoutExtracao}`
        );

        return result.data.layoutExtracao;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const getLayoutsRecorteByIdUsuarioApi = useCallback(
    async (IdUsuario: number): Promise<ILayoutRecorteTable[]> => {
      try {
        const result = await axiosAuthInstance.get(
          `/geo-veles/layout-recorte-projeto/usuario/${IdUsuario}`
        );
        return result.data.Layouts;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const createLayouRecortetApi = useCallback(
    async (data: {
      layout: IRecorte[];
      IdUsuario: number;
      NomeLayout: string;
    }): Promise<ILayoutRecorte> => {
      try {
        const result = await axiosAuthInstance.post(
          "/geo-veles/layout-recorte-projeto",
          {
            layout: data.layout,
            IdUsuario: data.IdUsuario,
            NomeLayout: data.NomeLayout,
          }
        );

        return result.data;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const updateLayoutRecorteApi = useCallback(
    async (data: {
      IdLayoutRecorte: number;
      NomeLayout: string;
      Recortes: IRecorte[];
    }): Promise<ILayoutRecorte> => {
      try {
        const result = await axiosAuthInstance.put(
          `/geo-veles/layout-recorte-projeto/${data.IdLayoutRecorte}`,
          {
            IdVelesGeoLayoutRecorte: data.IdLayoutRecorte,
            NomeLayout: data.NomeLayout,
            Recortes: data.Recortes
          }
        );
        return result.data;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  )

  return {
    deleteLayoutRecorteApi,
    getLayoutsRecorteByIdUsuarioApi,
    createLayouRecortetApi,
    updateLayoutRecorteApi,
  };
};
